module.exports = __webpack_public_path__ + "img/ico_biaoqianyuemaiyuezhi.17ad7d83.png";